import {
  LANDING_GET_CLUSTER_BY_CLUSTER_ID_REQUESTED,
  LANDING_GET_CLUSTER_BY_CLUSTER_ID_UPDATED,
  LOGOUT,
} from '../actionTypes';

const initialState = () => ({
  getClusterByClusterId: {
    data: null,
    loading: false,
    error: null,
  },
});

export const landingClusterReducer = (state = initialState(), action) => {
  switch (action.type) {
    case LANDING_GET_CLUSTER_BY_CLUSTER_ID_REQUESTED:
      return {
        ...state,
        getClusterByClusterId: {
          ...state.getClusterByClusterId,
          loading: true,
        },
      };
    case LANDING_GET_CLUSTER_BY_CLUSTER_ID_UPDATED:
      return {
        ...state,
        getClusterByClusterId: {
          data: action.payload.data,
          error: action.payload.error,
          loading: false,
        },
      };
    case LOGOUT:
      return initialState();
    default:
      return state;
  }
};
